





























import { Mixins, Component } from "vue-property-decorator";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import { TrialEndActionTypes } from "@/data/enums/products";
import Context from "@/mixins/context";

@Component
export default class CProdTrialMsg extends Mixins(CProdInjectorMixin, Context) {
  // Data

  public isProcessing = false;

  // Computed

  public get trialMsgPath() {
    const { trial_end_action } = this.cProdData.contractProduct;
    if (this.cProdData.isAwaitingActivation)
      return "_sentence.cprod.on_pending_trial_msg";
    // Migration trial
    if (trial_end_action === TrialEndActionTypes.MIGRATE)
      return "_sentence.cprod.on_migrating_trial_msg";
    // Cancelling trial
    if (trial_end_action === TrialEndActionTypes.CANCEL)
      return "_sentence.cprod.on_cancelling_trial_msg";
    // Continuing trial (default)
    return "_sentence.cprod.on_continuing_trial_msg";
  }

  // Methods

  public async endTrialEarly() {
    try {
      this.isProcessing = true;
      await this.$cProdMethods.endTrialEarly();
    } finally {
      this.isProcessing = false;
    }
  }
}
